<be-dialog-header [title]="title" [revisado]="revisado" (close)="close.emit()" [closeButton]="closeButton"></be-dialog-header>
<article class="dialog-content">
    <ng-content></ng-content>
</article>
<footer class="dialog-footer" *ngIf="showFooter">
    <ng-content select="dialog-actions"></ng-content>
</footer>